export class EsposizioneNetta {
  static IMPORT = 'Import';
  static EXPORT = 'Export';
}
